// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"b34ce34a","416":"6ef03ac7","538":"3d689878","565":"1f68a2a1","566":"c45165ac"}[chunkId] + ".chunk.js";
};